(function(){
  angular.module('edxComponents')
    .directive("standardsList", function () {
      return {
        restrict: "E",
        scope: {
          list: '=',
          standardSelected: '=',
          students: '=',
          item: '=',
          allowDomain: '='
        },
        transclude: true,
        templateUrl: '/resources/components/assign-focus/standards-list.directive.html',
        controller: [
          '$scope',
          '$element',
          '$filter',
          'standard',
          '$timeout',
          'customer',
          'assignMode',
          'edxCreateAstAssignmentConfigurationService',
          'configuration',
          StandardsListController]
      };
    });

  function StandardsListController (
    $scope,
    $element,
    $filter,
    $standard,
    $timeout,
    $customer,
    $assignMode,
    edxCreateAstAssignmentConfigurationService,
    configuration
    ) {

    $scope.hideStandardsList = hideStandardsList;
    $scope.isLite = configuration.isFeatureEnabled('dbl_lite');

    var translate = $filter('translate');
    var standardsClusterSelectName = translate('assignments.standardsClusterSelectName');
    var standardsClusterSearchName = translate('assignments.standardsClusterSearchName');
    var allStandardsInDomainText = translate('assignments.allStandardsInDomainText');

    var astName = $customer.getAcademicStandard().academic_standard_name;
    $scope.astName = astName;

    // replace ast specific text as needed
    var standardClusterSelectName;
    var defaultStandard;

    function astChanged() {
      standardClusterSelectName = $filter('domainText')(standardsClusterSelectName, astName);
      $scope.standardClusterSearchName = $filter('domainText')(standardsClusterSearchName, astName);
      defaultStandard = {
        name: standardClusterSelectName,
        percent_complete: -1
      };
      allStandardsInDomainText = $filter('domainText')(allStandardsInDomainText, astName);

      $scope.usingAltStandard = (astName === 'dbl' || astName === 'uk_standards_2013');
      $scope.standards = {
        expandedList: [],
        selected: defaultStandard
      };
    }

    astChanged();

    $scope.visible = false;
    $scope.standardSelected = false;
    $scope.assignMode = $assignMode.isAssignMode;

    $scope.showPercents = false;

    function flattenList(list) {
      $scope.standards.expandedList = [];

      // Iterate through standards and clusters and unravel them to
      // be on the same level.
      if (typeof list !== 'undefined') {
        if ($scope.allowDomain) {
          // Since we don't have a domain object in the list, create an item for the dropdown
          // and assume a proper domain object (with percent_complete, etc.) is availble in a higher
          // level controller after this item is clicked.
          var allStandardsInDomainItem = {
            name: allStandardsInDomainText,
            code: $standard.getParams().domain,
            domain: true
          };

          $scope.standards.expandedList.push(allStandardsInDomainItem);
        }

        // sometimes (e.g. all domains tab) we don't have clusters/standards to unravel
        list.forEach(function (cluster) {
          var clusterItem = angular.copy(cluster);
          clusterItem.cluster = true;

          if (clusterItem.name && clusterItem.name !== '---') {
            $scope.standards.expandedList.push(clusterItem);
          }

          cluster.standards.forEach(function (standard) {
            var standardItem = angular.copy(standard);
            if ($scope.usingAltStandard) {
              standardItem.name = standardItem.short_description;
            }
            standardItem.standard = true;
            $scope.standards.expandedList.push(standardItem);
          });
        });
      }

      $standard.updateSelectedStandard($scope.standards.expandedList);
      $scope.standards.selected = findSelected();

      broadcastSetStandard();
    }

    $scope.standardClicked = function (standard) {
      $scope.standards.selected = standard;
      broadcastSetStandard();
    };

    function findSelected() {
      var params = $standard.getParams();
      var focusType = $standard.getFocusType();
      var searchObj = {};

      if (focusType) {
        searchObj[focusType] = true;
      }
      searchObj.code = String(params.standard);

      return _.findWhere($scope.standards.expandedList, searchObj) || defaultStandard;
    }

    function broadcastSetStandard() {
      var params = $standard.getParams();
      if (params.standardProficiency) {
        var selectedStandard = _.find($scope.standards.expandedList, function(standard) { return  standard.code === params.standardProficiency; });
        if (selectedStandard) {
          $scope.standards.selected = selectedStandard;
        }
      }

      $scope.standardSelected = _.has($scope.standards.selected, 'code');

      var focusType;
      if ($scope.standards.selected.hasOwnProperty('domain')) {
        focusType = 'domain';
      } else if ($scope.standards.selected.hasOwnProperty('cluster')) {
        focusType = 'cluster';
      } else {
        focusType = 'standard';
      }

      var eventName = focusType + 'Clicked';

      var standardId = $scope.standards.selected && focusType !== 'domain' ? $scope.standards.selected.code : null;
      $standard.updateQueryParams({standard: standardId});

      $timeout(function () {
        $element.find('input').blur();
        $scope.$emit(eventName, $scope.standards.selected);

        // Make sure the selection is an actual standard or cluster before updating the focusType param
        // otherwise the pre-selected focusType gets clobbered and pre-selection of the cluster doesn't
        // work.  See bug IN-4373.
        if ($scope.standards.selected.code) {
          $standard.updateFocusTypeParam(focusType);
        }
      });

      if (eventName === 'standardClicked') {
        $scope.$emit("standardSelectedText", $scope.standards.selected.name, $scope.standards.selected.description);
      }
      else if (eventName === 'clusterClicked') {
        $scope.$emit("standardSelectedText", $scope.standards.selected.name);
      }
    }

    $scope.$watch('allowDomain', function (val) {
      if ($scope.list) {
        flattenList($scope.list.clusters);
      }
    });

    $scope.$watch('list', function () {
      // Hide standards list on 'All Domains' Tab
      var domainId = $standard.getParams().domain;
      var allDomainsTabId = 0;
      $scope.visible = ( domainId && domainId !== allDomainsTabId || $scope.assignMode === true );
      if(!$scope.visible) {
        $scope.standardSelected = false;
      }
    });

    $scope.$on('astChanged', function (e, data) {
      astName = data.astName;
      $scope.astName = astName;
      astChanged();
    });

    $scope.$on('standardsLoaded', function (e, data) {
      if (data.astName && data.astName !== astName) {
        astName = data.astName;
        $scope.astName = astName;
        astChanged();
      }

      flattenList(data.standards.clusters);

      if ($scope.standards.expandedList.length > 0 && hideStandardsList()) {
        var defaultSelection = _.find($scope.standards.expandedList, function (ast){ return ast.standard; });
        if (defaultSelection) {
          $scope.standards.selected = defaultSelection;
          broadcastSetStandard();
        }
      }
    });

    /**
     * Determines if the standards list drop down should be hidden.
     *
     * @return {*|boolean}
     */
    function hideStandardsList() {
      return edxCreateAstAssignmentConfigurationService[astName] && edxCreateAstAssignmentConfigurationService[astName].hideStandardsList;
    }
  }
})();
